import { render, staticRenderFns } from "./report_stu_zhushou_refactor.vue?vue&type=template&id=1236c39d&scoped=true&"
import script from "./report_stu_zhushou_refactor.vue?vue&type=script&lang=js&"
export * from "./report_stu_zhushou_refactor.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_zhushou_refactor.vue?vue&type=style&index=0&id=1236c39d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236c39d",
  null
  
)

export default component.exports